"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Overlay = /** @class */ (function () {
    function Overlay() {
        this.config = {
            overlay: null,
            selectors: {
                overlay: '[data-overlay]'
            },
            classNames: {
                on: 'overlay--on'
            }
        };
    }
    Overlay.prototype.init = function () {
        this.config.overlay = document.querySelector(this.config.selectors.overlay);
    };
    Overlay.prototype.on = function (zIndex) {
        this.config.overlay.style.zIndex = zIndex ? zIndex.toString() : this.config.overlay.style.zIndex;
        this.config.overlay.classList.add(this.config.classNames.on);
    };
    Overlay.prototype.off = function () {
        this.config.overlay.classList.remove(this.config.classNames.on);
    };
    return Overlay;
}());
exports.default = new Overlay();
